<script setup lang="ts">
import { defineAsyncComponent, inject } from "vue";
import { Brand } from "@/types";
import { APP } from "@/stores/app";
import { CONFIG } from "@/stores/config";
import { JETSTREAM } from "@/stores/jetstream";

const appStore = inject(APP)!;
const configStore = inject(CONFIG)!;
const jetstreamStore = inject(JETSTREAM)!;

const NgcTemplate = defineAsyncComponent(() => import("./NgcTemplate.vue"));
const DefaultTemplate = defineAsyncComponent(() => import("./DefaultTemplate.vue"));
const VwTemplate = defineAsyncComponent(() => import("./VwTemplate.vue"));
const CupraTemplate = defineAsyncComponent(() => import("./CupraTemplate.vue"));
const CupraExhibitionTemplate = defineAsyncComponent(() => import("./CupraExhibitionTemplate.vue"));
const VwExhibitionTemplate = defineAsyncComponent(() => import("./VwExhibitionTemplate.vue"));
const LamborghiniTemplate = defineAsyncComponent(() => import("./LamborghiniTemplate.vue"));

function getTemplateFromConfig() {
  const template = configStore.config?.template;

  if (!template) {
    // if template is not set in configuration then we use the default template for each brand
    const brand = configStore.config?.brand;
    switch (brand) {
      case Brand.Cupra:
        return CupraTemplate;
      case Brand.Volkswagen:
        return VwTemplate;
      case Brand.Lamborghini:
        return LamborghiniTemplate;
      case Brand.Audi:
        return NgcTemplate;
      default:
        return DefaultTemplate;
    }
  }

  switch (template.toLowerCase()) {
    case "ngc":
      return NgcTemplate;
    case "vw":
      return VwTemplate;
    case "cupra-exhibition":
      return CupraExhibitionTemplate;
    case "vw-exhibition":
      return VwExhibitionTemplate;
    case "default":
    default:
      return DefaultTemplate;
  }
}
</script>

<template>
  <div class="deck-ui-container" v-show="jetstreamStore.streamInitialized || appStore.dev">
    <component class="deck-ui" :is="getTemplateFromConfig()"></component>
  </div>
</template>

<style>
.deck-ui-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  box-sizing: border-box;
  padding: var(--deck-padding-width);
  pointer-events: none;
}

.deck-ui {
  position: relative;
  width: 100%;
  height: 100%;
}

.deck-icon-button,
.deck-gallery {
  pointer-events: all;
}
</style>
